import { useTheme } from "@mui/material/styles";

import { InputVibe } from "@/types/mui";

export const useCurrentInputVibe = (color?: InputVibe): InputVibe => {
  const { palette } = useTheme();
  return color || palette.component || "neutral";
};
